/**
 * The names of the loan documents that can be printed.
 * @constant {Object} LoanDocumentNames
 */
export const LoanDocumentNames = {
  // General Documents
  debServiceRatioSummary: 'Debt Service Ratio Summary',
  netWorthSummary: 'Net Worth Summary',
  creditAssessment: 'Credit Assessment',
  riskBasedOutcome: 'Risk Based Outcome',
  loanProcessingChecklist: 'Loan Processing Checklist',
  loanReviewChecklist: 'Loan Review Checklist',
  preApprovalChecklist: 'Pre-Approval Checklist',
  preDisbursementChecklist: 'Pre Disbursement Checklist',
  allComments: 'All Comments',
  insuranceSummary: 'Insurance Summary',
  collateralSummary: 'Collateral Summary',
  loanApprovalSummary: 'Loan Approval Summary',
  yapu: 'YAPU Climate Risk Assessment'
  // loanApplication: 'Loan Application',
  // Security Documents
  // billOfSales: 'Bill of Sales',
  // guarantee: 'Guarantee',
  // letterToCollectorate: 'Letter to Collector',
  // powerOfAttorney: 'Power Of Attorney',
  // offerLetter: 'Offer Letter',
  // promissoryNote: 'Promissory Note'
};
